export default "__VITE_ASSET__CugSbCZH__"